/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createFetchChargePointConsumptionResultFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, serializeFetchChargePointConsumptionCommand, serializeFetchChargePointConsumptionResult, type FetchChargePointConsumptionCommand, type FetchChargePointConsumptionResult, type ProblemDetails } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /fetch/chargepoint-consumption
 */
export interface ChargepointConsumptionRequestBuilder extends BaseRequestBuilder<ChargepointConsumptionRequestBuilder> {
    /**
     * FetchChargePointConsumption
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<FetchChargePointConsumptionResult>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     post(body: FetchChargePointConsumptionCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<FetchChargePointConsumptionResult | undefined>;
    /**
     * FetchChargePointConsumption
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: FetchChargePointConsumptionCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ChargepointConsumptionRequestBuilderUriTemplate = "{+baseurl}/fetch/chargepoint-consumption";
/**
 * Metadata for all the requests in the request builder.
 */
export const ChargepointConsumptionRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: ChargepointConsumptionRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createFetchChargePointConsumptionResultFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeFetchChargePointConsumptionCommand,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
